/* eslint-disable */

import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
// import jwt from 'jsonwebtoken';
import jwt_decode from 'jwt-decode';

const useAuth = () => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('type');
    const employeeRole = localStorage.getItem('employeeRole');
    // console.log(employeeRole, role, token);

    // decode the token to get its payload
    // const decodedToken = jwt.decode(token, { complete: true });
    if (token) {
        if (role === 'distributor' && employeeRole) {
            const decoded = jwt_decode(token);
            if (decoded.exp < Date.now() / 1000) {
                return 1;
            } else {
                // console.log('not expired');
                // The token is still valid
                const user = token;
                return user && token;
            }
        } else {
            console.log('unautherized page, you are not MIS');
            return 2;
        }
    } else {
        // console.log('token is nottt present');
        return 1;
    }
};

const ProtectedRouteEmployee = ({ element }) => {
    const isAuth = useAuth();
    if (isAuth) {
        if (isAuth === 1) {
            return <Navigate to="/" replace />;
        } else if (isAuth === 2) {
            return <Navigate to="/unauthorized" replace />;
        } else {
            return element;
        }
    } else {
        return <Navigate to="/" replace />;
    }
    // return isAuth ? element : <Navigate to="/login" replace />;
};

export default ProtectedRouteEmployee;
